/* Custom Protein Expression (CPE) theme behaviour
   Grade toggle, header menus, in-page navigation, quote form prefill.
   Uses event delegation so everything keeps working after the theme editor re-renders a section. */
(function () {
  var root = document.documentElement;

  /* ---- Non-GMP / GMP grade toggle ---- */
  function getStored() { try { return localStorage.getItem('cpe-grade'); } catch (e) { return null; } }
  function store(v) { try { localStorage.setItem('cpe-grade', v); } catch (e) {} }
  function syncButtons(g) {
    document.querySelectorAll('.cpe .toggle button[data-grade]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-grade') === g ? 'true' : 'false');
    });
  }
  function setGrade(g) { root.setAttribute('data-grade', g); syncButtons(g); store(g); }
  setGrade(getStored() === 'gmp' ? 'gmp' : 'nongmp');

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.cpe .toggle button[data-grade]');
    if (b) { setGrade(b.getAttribute('data-grade')); return; }

    var menuBtn = e.target.closest('.cpe .menu-btn');
    if (menuBtn) {
      var nav = document.getElementById(menuBtn.getAttribute('aria-controls'));
      if (nav) {
        var open = nav.classList.toggle('open');
        menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    var dropBtn = e.target.closest('.cpe .nav-drop > button');
    if (dropBtn) {
      var d = dropBtn.parentElement, willOpen = !d.classList.contains('open');
      closeDrops(d);
      d.classList.toggle('open', willOpen);
      dropBtn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }
    closeDrops(null, e.target);
  });

  function closeDrops(except, target) {
    document.querySelectorAll('.cpe .nav-drop.open').forEach(function (d) {
      if (d === except || (target && d.contains(target))) return;
      d.classList.remove('open');
      var btn = d.querySelector('button'); if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.cpe .nav-drop.open').forEach(function (d) {
      d.classList.remove('open');
      var b = d.querySelector('button'); if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
    });
  });

  /* ---- In-page navigation highlighting ---- */
  var observer;
  function initSubnav() {
    if (observer) observer.disconnect();
    var links = document.querySelectorAll('.cpe .subnav a[href^="#"]');
    if (!links.length || !('IntersectionObserver' in window)) return;
    var map = {};
    links.forEach(function (a) { map[decodeURIComponent(a.getAttribute('href').slice(1))] = a; });
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        links.forEach(function (a) { a.classList.remove('active'); });
        var a = map[en.target.id]; if (a) a.classList.add('active');
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    Object.keys(map).forEach(function (id) { var el = document.getElementById(id); if (el) observer.observe(el); });
  }

  /* ---- Quote form: prefill from ?service=…&grade=… and validate required fields ---- */
  function initForms() {
    var params = new URLSearchParams(location.search);
    document.querySelectorAll('.cpe form.quote').forEach(function (form) {
      ['service', 'grade'].forEach(function (key) {
        var val = params.get(key); if (!val) return;
        val = val.toLowerCase();
        form.querySelectorAll('[data-prefill="' + key + '"]').forEach(function (el) {
          if (el.tagName === 'SELECT') {
            Array.prototype.forEach.call(el.options, function (o) {
              if ((o.getAttribute('data-key') || '').toLowerCase() === val) el.value = o.value;
            });
          } else if (el.type === 'radio' && (el.getAttribute('data-key') || '').toLowerCase() === val) {
            el.checked = true;
          }
        });
      });
      if (form.dataset.cpeBound) return;
      form.dataset.cpeBound = '1';
      form.addEventListener('submit', function (e) {
        var first = null;
        form.querySelectorAll('[required]').forEach(function (el) {
          var err = document.getElementById(el.id + '-err');
          var bad = !String(el.value || '').trim() || (el.type === 'email' && !/^\S+@\S+\.\S+$/.test(el.value));
          if (err) err.classList.toggle('show', bad);
          el.setAttribute('aria-invalid', bad ? 'true' : 'false');
          if (bad && !first) first = el;
        });
        if (first) { e.preventDefault(); first.focus(); }
      });
    });
  }


  /* ---- Product page: variants, quantity, AJAX add to cart, gallery ---- */
  function money(el, txt) { if (el) el.textContent = txt; }
  function rootUrl() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function initProducts() {
    document.querySelectorAll('.cpe [data-cpe-product]').forEach(function (sec) {
      if (sec.dataset.cpeBound) return;
      sec.dataset.cpeBound = '1';
      var data = sec.querySelector('[data-cpe-variants]');
      var variants = [];
      try { variants = JSON.parse(data.textContent); } catch (e) {}
      var form = sec.querySelector('form');
      var zeroQuote = sec.getAttribute('data-zero-quote') === 'true';

      function selected() {
        var vals = [];
        sec.querySelectorAll('[data-cpe-option]').forEach(function (el) {
          var i = +el.getAttribute('data-cpe-option');
          if (el.type === 'radio') { if (el.checked) vals[i] = el.value; } else { vals[i] = el.value; }
        });
        return vals;
      }
      function match(vals) {
        return variants.find(function (v) { return v.options.every(function (o, i) { return vals[i] === undefined || vals[i] === o; }); });
      }
      function show(el, on) { if (el) el.hidden = !on; }

      function update(v) {
        var add = sec.querySelector('[data-cpe-add]');
        var vals = selected();
        vals.forEach(function (val, i) { var l = sec.querySelector('[data-cpe-option-label="' + i + '"]'); if (l) l.textContent = val; });
        if (!v) {
          if (add) { add.disabled = true; add.textContent = add.getAttribute('data-label-unavailable'); }
          return;
        }
        var idInput = sec.querySelector('[data-cpe-variant-id]'); if (idInput) idInput.value = v.id;
        var zero = zeroQuote && v.zero;
        var priceEl = sec.querySelector('[data-cpe-price]');
        money(priceEl, zero ? (priceEl.getAttribute('data-zero-label') || priceEl.textContent) : v.price);
        var cmp = sec.querySelector('[data-cpe-compare]'); if (cmp) { cmp.hidden = !v.compare || zero; if (v.compare) cmp.textContent = v.compare; }
        var unit = sec.querySelector('[data-cpe-unit]'); if (unit) { unit.hidden = !v.unit; unit.textContent = v.unit || ''; }
        show(sec.querySelector('[data-cpe-ship]'), !zero);
        show(sec.querySelector('[data-cpe-qty-wrap]'), !zero);
        show(sec.querySelector('[data-cpe-dyn]'), !zero);
        show(sec.querySelector('[data-cpe-quote]'), zero);
        if (add) {
          add.hidden = zero;
          add.disabled = !v.available;
          add.textContent = v.available ? add.getAttribute('data-label-add') : add.getAttribute('data-label-sold-out');
        }
        document.querySelectorAll('[data-cpe-sku]').forEach(function (el) {
          el.textContent = v.sku || '';
          var wrap = el.closest('.pp-sku'); if (wrap) wrap.hidden = !v.sku;
        });
        var stock = sec.querySelector('[data-cpe-stock]');
        if (stock) {
          stock.classList.toggle('out', !v.available);
          var t = stock.querySelector('[data-cpe-stock-text]');
          if (t) t.textContent = v.available ? stock.getAttribute('data-in') : stock.getAttribute('data-out');
        }
        if (v.media) showMedia(sec, v.media);
        try {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        } catch (e) {}
        refreshVariantSections(v.id);
      }

      sec.addEventListener('change', function (e) {
        if (e.target.matches('[data-cpe-option]')) update(match(selected()));
      });
      sec.addEventListener('click', function (e) {
        var q = e.target.closest('[data-cpe-qty]');
        if (q) {
          var input = sec.querySelector('input[name="quantity"]');
          var step = +input.step || 1, min = +input.min || 1, max = input.max ? +input.max : Infinity;
          var next = Math.min(max, Math.max(min, (+input.value || min) + step * +q.getAttribute('data-cpe-qty')));
          input.value = next;
          return;
        }
        var th = e.target.closest('[data-cpe-thumb]');
        if (th) showMedia(sec, th.getAttribute('data-cpe-thumb'));
      });

      if (form && sec.getAttribute('data-after-add') !== 'cart') {
        form.addEventListener('submit', function (e) {
          if (!window.fetch || !window.FormData) return;
          e.preventDefault();
          var add = sec.querySelector('[data-cpe-add]');
          var status = sec.querySelector('[data-cpe-status]');
          if (add) add.classList.add('loading');
          fetch(rootUrl() + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
            .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
            .then(function (res) {
              if (add) add.classList.remove('loading');
              if (!status) return;
              if (res.ok) {
                status.className = 'pp-status ok';
                status.innerHTML = '';
                status.appendChild(document.createTextNode(status.getAttribute('data-added') + ' '));
                var a = document.createElement('a'); a.href = status.getAttribute('data-cart-url'); a.textContent = status.getAttribute('data-view');
                status.appendChild(a);
                updateCartCount();
              } else {
                status.className = 'pp-status err';
                status.textContent = (res.body && (res.body.description || res.body.message)) || status.getAttribute('data-error');
              }
            })
            .catch(function () { if (add) add.classList.remove('loading'); form.submit(); });
        });
      }
    });
  }

  function showMedia(sec, id) {
    var g = sec.querySelector('[data-cpe-gallery]'); if (!g) return;
    var found = g.querySelector('[data-media-id="' + id + '"]'); if (!found) return;
    g.querySelectorAll('[data-media-id]').forEach(function (s) { s.hidden = s !== found; });
    g.querySelectorAll('[data-cpe-thumb]').forEach(function (b) { b.setAttribute('aria-current', b.getAttribute('data-cpe-thumb') === String(id) ? 'true' : 'false'); });
  }

  function refreshVariantSections(variantId) {
    document.querySelectorAll('[data-cpe-variant-section]').forEach(function (el) {
      var sid = el.getAttribute('data-cpe-variant-section');
      var wrapper = document.getElementById('shopify-section-' + sid);
      if (!wrapper || !window.fetch) return;
      fetch(window.location.pathname + '?variant=' + variantId + '&section_id=' + encodeURIComponent(sid))
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('shopify-section-' + sid);
          if (fresh) wrapper.innerHTML = fresh.innerHTML;
        }).catch(function () {});
    });
  }

  function updateCartCount() {
    if (!window.fetch) return;
    fetch(rootUrl() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cpe .nav-icons a[href*="cart"]').forEach(function (a) {
          var c = a.querySelector('.count');
          if (!c) { c = document.createElement('span'); c.className = 'count'; a.appendChild(c); }
          c.textContent = cart.item_count;
          c.hidden = !cart.item_count;
        });
      }).catch(function () {});
  }

  /* ---- Copy buttons for sequences ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.cpe [data-cpe-copy]');
    if (!b) return;
    var code = b.parentElement.querySelector('code');
    if (!code || !navigator.clipboard) return;
    navigator.clipboard.writeText(code.textContent.replace(/\s+/g, '')).then(function () {
      var t = b.textContent; b.textContent = 'Copied'; setTimeout(function () { b.textContent = t; }, 1500);
    });
  });

  /* ---- Header search: predictive suggestions ---- */
  var psTimer, psController;
  function psClose(form) {
    var pop = form.querySelector('[data-cpe-ps]'); var input = form.querySelector('input[name="q"]');
    if (pop) { pop.hidden = true; }
    if (input) input.setAttribute('aria-expanded', 'false');
  }
  function psFetch(form) {
    var input = form.querySelector('input[name="q"]'); var pop = form.querySelector('[data-cpe-ps]');
    var q = input.value.trim();
    if (q.length < 2) { psClose(form); return; }
    var types = form.getAttribute('data-products-only') === 'true' ? 'product,query' : 'query,product,page,article';
    var limit = form.getAttribute('data-limit') || 6;
    var url = rootUrl() + 'search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=' + types +
      '&resources[limit]=' + limit + '&resources[limit_scope]=each&resources[options][unavailable_products]=last&section_id=cpe-predictive-search';
    if (psController) psController.abort();
    psController = window.AbortController ? new AbortController() : null;
    fetch(url, psController ? { signal: psController.signal } : {})
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) { psClose(form); return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrap = doc.getElementById('shopify-section-cpe-predictive-search');
        pop.innerHTML = wrap ? wrap.innerHTML : html;
        pop.hidden = !pop.textContent.trim();
        input.setAttribute('aria-expanded', pop.hidden ? 'false' : 'true');
      }).catch(function () {});
  }
  document.addEventListener('input', function (e) {
    var form = e.target.closest('.cpe form[data-cpe-search][data-predictive="true"]');
    if (!form || e.target.name !== 'q') return;
    clearTimeout(psTimer); psTimer = setTimeout(function () { psFetch(form); }, 220);
  });
  document.addEventListener('keydown', function (e) {
    var form = e.target.closest && e.target.closest('.cpe form[data-cpe-search]');
    if (!form) return;
    var pop = form.querySelector('[data-cpe-ps]');
    if (e.key === 'Escape') { psClose(form); return; }
    if (!pop || pop.hidden || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
    var links = Array.prototype.slice.call(pop.querySelectorAll('.ps-link'));
    if (!links.length) return;
    e.preventDefault();
    var i = links.indexOf(document.activeElement);
    i = e.key === 'ArrowDown' ? Math.min(links.length - 1, i + 1) : i - 1;
    if (i < 0) { form.querySelector('input[name="q"]').focus(); return; }
    links[i].focus();
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.cpe form[data-cpe-search]').forEach(function (f) { if (!f.contains(e.target)) psClose(f); });
  });

  /* ---- Listing: filters, sort, view, pagination without full reloads ---- */
  function viewGet() { try { return localStorage.getItem('cpe-view'); } catch (e) { return null; } }
  function viewSet(v) { try { localStorage.setItem('cpe-view', v); } catch (e) {} }
  function applyView(scope) {
    var stored = viewGet();
    scope.querySelectorAll('[data-cpe-results]').forEach(function (r) {
      var listing = r.closest('[data-cpe-listing]');
      var hasToggle = listing && listing.querySelector('[data-cpe-view]');
      var v = (hasToggle && stored) || r.getAttribute('data-default-view') || 'list';
      r.classList.remove('view-list', 'view-grid'); r.classList.add('view-' + v);
      if (listing) listing.querySelectorAll('[data-cpe-view]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cpe-view') === v ? 'true' : 'false'); });
    });
  }
  function listingUrl(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (val, key) { if (String(val).trim() !== '') params.append(key, val); });
    var action = form.getAttribute('action') || window.location.pathname;
    return action + (action.indexOf('?') > -1 ? '&' : '?') + params.toString();
  }
  function loadListing(listing, url, push) {
    var sid = listing.getAttribute('data-cpe-listing');
    var wrapper = document.getElementById('shopify-section-' + sid);
    if (!wrapper || !window.fetch) { window.location.href = url; return; }
    var drawerOpen = !!listing.querySelector('[data-cpe-drawer].open');
    var focusedName = document.activeElement && document.activeElement.name;
    var box = listing.querySelector('.listing'); if (box) box.classList.add('is-loading');
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid))
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('shopify-section-' + sid);
        if (!fresh) { window.location.href = url; return; }
        wrapper.innerHTML = fresh.innerHTML;
        if (push) window.history.pushState({ cpeListing: sid }, '', url);
        applyView(wrapper);
        if (drawerOpen) { var d = wrapper.querySelector('[data-cpe-drawer]'); if (d) { d.classList.add('open'); document.documentElement.classList.add('cpe-lock'); } }
        if (focusedName) { var el = wrapper.querySelector('[name="' + focusedName.replace(/"/g, '\\"') + '"]'); if (el && el.type !== 'checkbox') el.focus(); }
      })
      .catch(function () { window.location.href = url; });
  }
  var priceTimer;
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-cpe-facet-find]')) return;
    var form = t.form && t.form.matches('[data-cpe-facets]') ? t.form : null;
    if (!form) return;
    var listing = form.closest('[data-cpe-listing]'); if (!listing) return;
    var go = function () { loadListing(listing, listingUrl(form), true); };
    if (t.type === 'number') { clearTimeout(priceTimer); priceTimer = setTimeout(go, 500); } else go();
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('.cpe form[data-cpe-facets]')) return;
    var listing = form.closest('[data-cpe-listing]'); if (!listing) return;
    e.preventDefault(); loadListing(listing, listingUrl(form), true);
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.cpe [data-cpe-listing] a[data-cpe-ajax]');
    if (a && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      loadListing(a.closest('[data-cpe-listing]'), a.getAttribute('href'), true);
      return;
    }
    var vb = e.target.closest('.cpe [data-cpe-view]');
    if (vb) { viewSet(vb.getAttribute('data-cpe-view')); applyView(vb.closest('[data-cpe-listing]') || document); return; }
    var more = e.target.closest('.cpe [data-cpe-facet-more]');
    if (more) {
      var list = more.parentElement.querySelector('[data-cpe-facet-list]');
      var open = list.classList.toggle('expanded');
      if (!more.dataset.more) more.dataset.more = more.textContent;
      more.textContent = open ? more.getAttribute('data-less') : more.dataset.more;
      return;
    }
    var op = e.target.closest('.cpe [data-cpe-drawer-open]');
    if (op) {
      var d = op.closest('[data-cpe-listing]').querySelector('[data-cpe-drawer]');
      if (d) { d.classList.add('open'); document.documentElement.classList.add('cpe-lock'); var c = d.querySelector('[data-cpe-drawer-close]'); if (c) c.focus(); }
      return;
    }
    var cl = e.target.closest('.cpe [data-cpe-drawer-close]');
    if (cl) { var dr = cl.closest('[data-cpe-drawer]'); if (dr) dr.classList.remove('open'); document.documentElement.classList.remove('cpe-lock'); }
  });
  document.addEventListener('input', function (e) {
    var f = e.target.closest('.cpe [data-cpe-facet-find]');
    if (!f) return;
    var q = f.value.trim().toLowerCase();
    var list = f.parentElement.querySelector('[data-cpe-facet-list]');
    list.classList.toggle('finding', q !== '');
    list.querySelectorAll('li').forEach(function (li) { li.classList.toggle('no-hit', q !== '' && (li.getAttribute('data-label') || '').indexOf(q) === -1); });
  });
  window.addEventListener('popstate', function () {
    var listing = document.querySelector('.cpe [data-cpe-listing]');
    if (listing) loadListing(listing, window.location.href, false);
  });

  function init() { syncButtons(root.getAttribute('data-grade') || 'nongmp'); initSubnav(); initForms(); initProducts(); applyView(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { setTimeout(initSubnav, 50); });
})();
